<template>
<div class="small-12 medium-6 large-4 columns person">
  <a :href="url">
    <div class="row responsaveis_uc2" data-equalizer-watch>
      <p class="responsavel_lable">
        {{ $t("UMA_LANG_SARESPONSAVELWORD") }}
      </p>
      <div class="imagem_orgao">
        <span class="circulo2"
          :style="[imagem != '' ? { 'backgroundImage': 'url('+imagem+')'}: {}]"></span>
      </div>
      <div class="descricao_orgao">
        <h5 class="responsavel_nome">{{nome}}</h5>
        <h6 class="responsavel_cargo">{{email}}</h6>
      </div>
    </div>
  </a>
</div>
</template>

<script>
export default {
  props:["nome","email","imagem","url"],
  setup () {
    


    return {}
  }
}
</script>

<style lang="scss" scoped>
.person {
  margin-bottom: 12px;
  padding-left: 0px;
  padding-right: 25px;
}

.person:first-of-type .responsavel_lable {
  display: inline-block;
}

.responsaveis_uc2 {
  background-color: #f4f4f4;
  margin-left: 2px !important;
  display: flex;
  flex-direction: row;
  position: relative;
}

.responsavel_nome {
  font-family: 'PT Sans';
  line-height: 1.4;
  font-size: 16px;
  margin-bottom: 0;
}

.responsavel_cargo {
  font-family: 'PT Sans Bold Italic';
  font-size: 16px;
  margin-top: .5rem;
  word-break: break-all;
}

.responsavel_lable {
  position: absolute;
  display: none;
  top: 0;
  right: 0;
  background-color: #79b2dc;
  padding: 3px 10px 3px 12px;
  line-height: 1.4;
  color: white;
  font-size: 12px;
  font-family: Montserrat;
  text-transform: uppercase;
}

.person:first-of-type .responsavel_lable {
  display: inline-block;
}

.descricao_orgao {
  display: flex;
  flex: 2;
  flex-direction: column;
  margin-right: 15px;
  padding-top: 30px;
  color: #535d61;
}

.circulo2 {
  display: block;
  background: black;
  border-radius: 50%;
  height: 80px;
  width: 80px;
  background: #b1b1b1;
  margin: 25px 20px;
  background-size: cover;
  background-position: center;
}

@media (max-width: 1280px) {
  .person {
    padding-right: 5px;
    padding-left: 5px;
  }

  .circulo2 {
    display: none;
  }

  .descricao_orgao {
    padding-left: 25px;
    padding-bottom: 30px;

  }
}

@media (max-width: 767px) {

  .person {
    margin-bottom: 5px;
  }

  .person:last-of-type {
    padding-bottom: 50px;
  }

  .person:first-of-type .descricao_orgao {
    padding-top: 29px;
  }

  .person:first-of-type .responsavel_lable {
    font-size: 10px;
  }

  .responsaveis_uc2 {
    margin-left: 0 !important;
  }

  .descricao_orgao .responsavel_nome,
  .descricao_orgao .responsavel_cargo {
    font-size: 14px;
  }

  .descricao_orgao {
    padding-top: 18px;
    padding-bottom: 18px;
  }

  .responsavel_nome{
    margin-bottom: 1px;
  }

  .responsavel_cargo {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>